module.exports = __webpack_public_path__ + "static/media/WhitneySSm-Semibold-Adv_Web.e19d1003.woff2";